import {ModalContext} from '#/contexts/modal-provider';
import {WalletContext} from '#/contexts/wallet-provider';
import {useFundingStatus} from '#/hooks/query/use-funding-status';
import {useContext, useEffect, useRef} from 'react';

export const useTestnetAccountFunding = () => {
  const {
    accountResult: {address, isConnected},
    web3Auth,
  } = useContext(WalletContext);
  const {open} = useContext(ModalContext);

  const {data: fundingStatus, isLoading: fundingStatusIsLoading} = useFundingStatus();

  const didLoad = useRef(false);

  useEffect(() => {
    if (!address || !isConnected || !web3Auth?.connected || didLoad.current || fundingStatusIsLoading) {
      return;
    }

    if (!fundingStatus) {
      setTimeout(() => {
        open({name: 'NewAccountFundedModal', props: {}});
      }, 750);

      didLoad.current = true;
    }
  }, [address, fundingStatus, fundingStatusIsLoading, isConnected, open, web3Auth?.connected]);
};
